import { NgModule, isDevMode } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';

import { SharedModule } from '../shared/shared.module';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { CoreModule } from '../core/core.module';
import { HttpClientModule } from '@angular/common/http';
import { NgTemplateOutlet } from '@angular/common';

import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import { StoreDevtoolsModule } from '@ngrx/store-devtools';

import { ActUserModule } from '@features/act-user/act-user.module';
import { rootReducers } from '../store/root-reducers';
import { rootEffects } from '../store/root-effects';
import { NgIdleModule } from '@ng-idle/core';
import { Keepalive } from '@ng-idle/keepalive';
import { ServiceWorkerModule } from '@angular/service-worker';
import { AppIframeComponent } from '../app-iframe.component';
import { AppRoutingIframeModule } from '../app-routing-iframe.module';

const isIE =
  window.navigator.userAgent.indexOf('MSIE ') > -1 ||
  window.navigator.userAgent.indexOf('Trident/') > -1;

@NgModule({
  declarations: [AppIframeComponent],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    AppRoutingIframeModule,
    CoreModule,
    SharedModule,

    HttpClientModule,
    NgTemplateOutlet,
    // StoreRouterConnectingModule.forRoot(),
    StoreModule.forRoot(rootReducers),
    EffectsModule.forRoot(rootEffects), // It was added for the creation of providers because the 'createFeature' function doesn't handle it
    StoreDevtoolsModule.instrument({
      logOnly: !isDevMode(),
      connectInZone: true,
    }),
    NgIdleModule.forRoot(),
    ActUserModule,

    StoreDevtoolsModule.instrument({
      maxAge: 25, // Retains last 25 states
      logOnly: !isDevMode(), // Restrict extension to log-only mode }),
      connectInZone: true,
    }),
    ServiceWorkerModule.register('ngsw-worker.js', {
      enabled: !isDevMode(),
      // Register the ServiceWorker as soon as the application is stable
      // or after 30 seconds (whichever comes first).
      registrationStrategy: 'registerWhenStable:30000',
    }),
  ],
  providers: [Keepalive],
  bootstrap: [AppIframeComponent],
})
export class AppIframeModule {}
